import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Dimmer, Loader } from 'semantic-ui-react'

import { handleAuthentication } from '../../helpers/auth'
import { tr } from '../../helpers/languages'
import { actions as messages } from '../../store/actions/messages'
import { actions as profiles } from '../../store/actions/profiles'
import { actions as users } from '../../store/actions/users'

class Callback extends Component {
    constructor (props) {
        super(props)
        autoBind(this)
    }

    componentDidMount () {
        // Handle the authentication result.
        handleAuthentication()
            .then((result) => {
                const idTokenPayload = result.idTokenPayload
                // Only therapists have access to the portal.
                const role = idTokenPayload.role
                if (role !== 'therapist') {
                    throw new Error('Only therapists have access.')
                }
                // Keep the access token and when it expires.
                this.props.setUserTokens({
                    accessToken:{token: result.accessToken},
                    idToken:{token: result.idToken}
                })

                // Keep the email.
                const email = idTokenPayload.email
                this.props.setProfile({ email })
                // And then go to the dashboard.
                this.props.history.push('/dashboard')
            })
            .catch((error) => {
                // Failed to authenticate the therapist.
                // eslint-disable-next-line no-console
                console.error('Failed to log in.', error)
                this.props.message({ type: 'error', text: tr('FAILED_TO_LOG_IN') })
                // Go back to the login page.
                this.props.history.push('/')
            })
    }

    render () {
        return (
            <Container className='waiting'>
                <Dimmer active inverted>
                    <Loader size='large'/>
                </Dimmer>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    const _profiles = bindActionCreators(profiles, dispatch)
    const _users = bindActionCreators(users, dispatch)
    return {
        message: _messages.message,
        setUserTokens: _users.setUserTokens,
        setProfile: _profiles.setProfile
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Callback))



// WEBPACK FOOTER //
// ./src/components/callback/index.js